var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.goal && _vm.activity)?_c('ActivityResultForm',{ref:"form",attrs:{"activity-object":_vm._activity,"goal-object":_vm.goal,"is-edit":true,"is-draft":_vm.isDraft,"attachment-option":_vm.attachmentOption},on:{"onClickSave":_vm.handleClickSave,"onClickDraft":_vm.updateDraft,"onClickDelete":_vm.handleClickDelete}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }